export default "__VITE_ASSET__D2IBlm8M__"